import { StruggleCompetency, StruggleData } from '@/models/groups/report';
import { Vue, Component, Prop } from 'vue-property-decorator';
import * as d3 from 'd3';

@Component({
    name: 'struggling-domain-card',
})

export default class StrugglingDomainCard extends Vue {


    // ------------------------------------------------------
    // Properties

    @Prop()
    private strugglingCompetencies!: StruggleData[];

    @Prop()
    private learningReportData: any;

    private showMore: boolean = false;

    // -----------------------------------------
    // Hooks


    // ----------------------------------------------------
    // Methods

    private iconLoader(competencies: StruggleCompetency[], count: any) {
        const userCount = count <= 7 ? count : 7;
        return userCount ? new Array(userCount).fill({}) : [];
    }


}
